import React from 'react';
import _noop from 'lodash/noop';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { RefundTournamentT } from '../types';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from '../utils/formConfig';
import useContent from '../utils/useContent';
import { ADMIN_ACTION_TYPES } from '../utils/constants';

const Content = (props: RefundTournamentT) => {
	const { handleForceUpdate = _noop, ltid, mttid, cgrid } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useContent({
		handleForceUpdate,
		adminActionType: ADMIN_ACTION_TYPES.REFUND_TOURNAMENT,
		ltid,
		mttid,
		cgrid
	});

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{
					submitLabel: 'Refund',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default Content;
